import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import styles from './index.css';

class LeftNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.leftNav}>
                {content.map((item, index) => (
                    <div key={index} className={styles.box}>
                        <h3>
                            <a href={item.url} rel={rel} target="_blank">
                                {item.title}
                            </a>
                        </h3>
                        {item.subItems && (
                            <div>
                                {item.subItems.map &&
                                    item.subItems.map((item, index) => (
                                        <p key={index}>
                                            <a href={item.url} rel={rel} target="_blank">
                                                {item.title}
                                            </a>
                                        </p>
                                    ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    }
}

export default errorBoundary(LeftNav);
